import * as THREE from 'three';
import { szene, lader } from './index';
import Spieler from './Spieler';


export default class Terrain {
	// Attribute
	public breite: number;
	public höhe: number;
	public dicke: number;

	// Beinflusst die Anzahl von Portalen, beinflusst Performance stark
	public blockGröße = 1;
	public seitenAbstand = this.blockGröße / 2;
	// PortalModel das für Performance instanziiert wird
	private portalModel: THREE.Mesh;

	public instanziierteMeshe = new THREE.Group();
	constructor(breite = 20, höhe = 20, dicke = 20) {
		this.breite = breite;
		this.höhe = höhe;
		this.dicke = dicke;
		
		this.portalModel = new THREE.Mesh(new THREE.CylinderGeometry(this.blockGröße, this.blockGröße, this.blockGröße, 16, 16, true), new THREE.MeshBasicMaterial({color: 0x00bcd4, wireframe: true}));
		this.portalModel.geometry.scale(this.blockGröße / 3, this.blockGröße / 3, this.blockGröße / 3);
		this.kreeireInstanzierteMeshe();
		
	}

	// Kreation

	kreeireInstanzierteMeshe = () => {
		// Addiert die 2 vollen Seiten auf einer Achse vom Viereck mit den nicht gefüllten  
		// Seiten um die Nummer von gebrauchten Quadraten zu holen
		// Dividiere mit der Block Größe
		const anzahlVonInstanzen = (this.breite * this.höhe * 2) + ((this.höhe * 2 + this.breite * 2) * this.dicke) / this.blockGröße;
		this.instanziierteMeshe.add(new THREE.InstancedMesh(this.portalModel.geometry, this.portalModel.material, anzahlVonInstanzen));
	}

	// https://codeburst.io/infinite-scene-with-threejs-and-instancedmesh-adc74b8efcf4
	// Bewegt ein dummy Object damit man die Position davon in einer Matrix umwandeln   
	// kann und diese Matrix dann benutzt um die Instanz zu positionieren

	bewegeInstanziiertesMesh(meshDummy: THREE.Object3D, rotierungsVektor: THREE.Vector3, meshIndex: number,  x: number, y: number, z: number) {
		meshDummy.position.set(x, y, z);
		// Rotiere den Dummy, damit die PortalInstanz nach Vorne schaut, aber nur, wenn es nötig ist
		//if(rotierungsVektor.x > -100) meshDummy.lookAt(rotierungsVektor);
		meshDummy.setRotationFromAxisAngle(rotierungsVektor, Math.PI / 2);
		meshDummy.updateMatrix();
		this.instanziierteMeshe.children.map((instanziiertesMesh: any) => {
			instanziiertesMesh.setMatrixAt(meshIndex, meshDummy.matrix);
		});
	}

	kreeireTerrain() {
		const meshDummy = new THREE.Object3D();
		meshDummy.matrixAutoUpdate = false;
		this.instanziierteMeshe.matrixAutoUpdate = false;
		let instanziierteMesheIndex = 0;
		const rotierungsVektor = new THREE.Vector3();
		// Kreeire zuerst die zwei Seiten des Würfels
		for(let z = -this.seitenAbstand; z <= this.dicke; z += this.dicke) {
			for(let y = 0; y < this.höhe; y += this.blockGröße) {
				for(let x = 0; x < this.breite; x += this.blockGröße) {
					rotierungsVektor.set(1, 0, 0);

					this.bewegeInstanziiertesMesh(meshDummy, rotierungsVektor, instanziierteMesheIndex, x, y, z);
					instanziierteMesheIndex++;
				}
			}
		}
		// Kreeire die Seiten dazwischen, die leer sind
		for(let z = 0; z < this.dicke; z += this.blockGröße) {
			// Horizentale Seiten ein Block tiefer und höher als erste zwei Seiten
			for(let y = -this.seitenAbstand; y <= this.höhe - this.seitenAbstand; y += this.höhe) {
				for(let x = 0; x < this.breite; x += this.blockGröße) {
					rotierungsVektor.set(0, 1, 0);
					this.bewegeInstanziiertesMesh(meshDummy, rotierungsVektor, instanziierteMesheIndex, x, y, z);
					instanziierteMesheIndex++;
				}
			}	
			// Vertikale Seiten ein Block mehr nach links und rechts als die ersten zwei Seiten
			for(let x = -this.seitenAbstand; x <= this.breite - this.seitenAbstand; x += this.breite) {
				for(let y = 0; y < this.höhe; y += this.blockGröße) {
					rotierungsVektor.set(0, 0, 1);
					this.bewegeInstanziiertesMesh(meshDummy, rotierungsVektor, instanziierteMesheIndex, x, y, z);
					instanziierteMesheIndex++;
				}
			}
		}
		this.instanziierteMeshe.children.map((instanziiertesMesh: any) => {
			instanziiertesMesh.updateMatrix();
			instanziiertesMesh.instanceMatrix.needsUpdate = true;
		});
	}

	verarbeiteKollissionenMitSpieler(spieler: Spieler) {
		// Gehe durch alle Schlangenblöcke nach, und gucke, 
		// ob sie außerhalb des Terrains liegen
		spieler.blockListe.map((spielerBlock) => {
			const spielerBlockPosition = spielerBlock.mesh.position;
			if(spielerBlockPosition.y >= this.höhe - this.seitenAbstand) {
				spielerBlockPosition.y = -this.seitenAbstand; 
			} else if(spielerBlockPosition.y <= -this.seitenAbstand) {
				spielerBlockPosition.y = this.höhe - this.seitenAbstand;
			}

			if(spielerBlockPosition.x >= this.breite - this.seitenAbstand) {
				spielerBlockPosition.x = this.seitenAbstand;
			} else if(spielerBlockPosition.x <= -this.seitenAbstand) {
				spielerBlockPosition.x = this.breite - this.seitenAbstand;
			}

			if(spielerBlockPosition.z >= this.dicke - this.seitenAbstand) {
				spielerBlockPosition.z = -this.seitenAbstand;
			} else if(spielerBlockPosition.z <= -this.seitenAbstand) {
				spielerBlockPosition.z = this.dicke - this.seitenAbstand;
			}
			spielerBlock.mesh.updateMatrix();
		});
	}

	setzeGrößeNeu(größe: THREE.Vector3) {
		// Aktualisiere die Größen
		this.breite = größe.x;
		this.höhe = größe.y;
		this.dicke = größe.z;
		// Erstelle neue Terrain Instanzen
		szene.remove(this.instanziierteMeshe);
		this.instanziierteMeshe.children.map((instanziiertesMesh: any) => {
			instanziiertesMesh.dispose();
		})
		this.instanziierteMeshe = new THREE.Group();
		this.kreeireInstanzierteMeshe();
		this.kreeireTerrain();
		szene.add(this.instanziierteMeshe);
	}
}